import { Backdrop, SxProps, Theme } from '@mui/material';

import { Loader } from './Loader';

interface OverlayLoaderProps {
  open: boolean;
  message?: string;
  opacity?: number;
}

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    zIndex: (theme) => theme.zIndex.drawer + 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export function OverlayLoader({ open, message, opacity = 0.6 }: OverlayLoaderProps) {
  return (
    <Backdrop
      sx={{ ...customStyles.root, background: `rgba(250, 251, 255, ${opacity})` }}
      open={open}
    >
      <Loader message={message} />
    </Backdrop>
  );
}
